document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.features-accordion-cottolio');

  sections.forEach(function (section) {
    const items = section.querySelectorAll('.features-accordion-cottolio__item');
    const media = section.querySelector('.features-accordion-cottolio__media');
    const imageWrappers = media
      ? media.querySelectorAll('.features-accordion-cottolio__image-wrapper')
      : [];
    const wrapperByIndex = new Map();
    imageWrappers.forEach(function (wrapper) {
      const idx = parseInt(wrapper.dataset.imageIndex, 10);
      if (!Number.isNaN(idx)) wrapperByIndex.set(idx, wrapper);
    });

    function setImageActive(index) {
      wrapperByIndex.forEach(function (wrapper, wrapperIndex) {
        const isActive = wrapperIndex === index;
        wrapper.classList.toggle('is-active', isActive);
        wrapper.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });
    }

    function closePanel(panel, toggle) {
      if (!panel || !panel.classList.contains('is-open')) return;

      panel.classList.remove('is-open');

      if (toggle) toggle.setAttribute('aria-expanded', 'false');

      const onEnd = function (event) {
        if (event.target !== panel || event.propertyName !== 'grid-template-rows') return;
        panel.removeEventListener('transitionend', onEnd);
        if (!panel.classList.contains('is-open')) panel.hidden = true;
      };

      panel.addEventListener('transitionend', onEnd);
    }

    function openPanel(panel, toggle) {
      if (!panel) return;

      panel.hidden = false;
      requestAnimationFrame(function () {
        panel.classList.add('is-open');
      });

      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }

    items.forEach(function (item) {
      const toggle = item.querySelector('.features-accordion-cottolio__toggle');
      if (!toggle) return;

      toggle.addEventListener('click', function () {
        const panel = item.querySelector('.features-accordion-cottolio__panel');
        const isActive = item.classList.contains('is-active');
        const index = Array.prototype.indexOf.call(items, item) + 1;

        items.forEach(function (otherItem) {
          if (otherItem === item || !otherItem.classList.contains('is-active')) return;

          otherItem.classList.remove('is-active');
          closePanel(
            otherItem.querySelector('.features-accordion-cottolio__panel'),
            otherItem.querySelector('.features-accordion-cottolio__toggle')
          );
        });

        if (isActive) {
          item.classList.remove('is-active');
          closePanel(panel, toggle);
        } else {
          item.classList.add('is-active');
          openPanel(panel, toggle);
          setImageActive(index);
        }
      });
    });
  });
});
